import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Pagination, Response } from '@ui/src';
import { rateRequestApi } from '../services';
import { RateRequest } from '../../types';

export interface RateRequestListState {
  rateRequest?: RateRequest[];
  pagination?: Pagination;
  errorsList?: string;
}

const initialState: RateRequestListState = {};

export const rateRequestListSlice = createSlice({
  name: 'rateRequest',
  initialState,
  reducers: {
    clearRateRequestListState: (state) => {
      state.rateRequest = undefined;
      state.pagination = undefined;
      state.errorsList = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      rateRequestApi.endpoints.getRateRequest.matchPending,
      (state) => {
        state.errorsList = undefined;
      },
    );
    builder.addMatcher(
      rateRequestApi.endpoints.getRateRequest.matchRejected,
      (state, action: any) => {
        state.rateRequest = undefined;
        state.pagination = undefined;

        if (action?.payload.data) {
          if (Array.isArray(action?.payload.data?.message)) {
            state.errorsList = action?.payload.data?.message
              ?.map((item: { value: string }) => item.value)
              .join('; ');
          } else {
            state.errorsList = action?.payload.data?.error;
          }
        }
      },
    );
    builder.addMatcher(
      rateRequestApi.endpoints.getRateRequest.matchFulfilled,
      (state, action: PayloadAction<Response<RateRequest>>) => {
        state.rateRequest = action.payload.data.edges.map((item) => ({
          ...item.node,
        }));

        state.pagination = action.payload.data.pageInfo;
      },
    );
    builder.addMatcher(
      rateRequestApi.endpoints.changeRateRequestStatus.matchFulfilled,
      (state, action: PayloadAction<{ data: RateRequest }>) => {
        state.rateRequest = state.rateRequest?.map((item) => {
          const result = { ...item };

          if (result.id === action.payload.data.id) {
            result.active = action.payload.data.active;
          }

          return result;
        });
      },
    );
    builder.addMatcher(
      rateRequestApi.endpoints.updateRateRequestsPair.matchFulfilled,
      (state, action: PayloadAction<{ data: RateRequest }>) => {
        state.rateRequest = state.rateRequest?.map((item) => {
          let result = { ...item };

          if (result.id === action.payload.data.id) {
            result = action.payload.data;
          }

          return result;
        });
      },
    );
  },
});

export const { clearRateRequestListState } = rateRequestListSlice.actions;

export default rateRequestListSlice.reducer;
